/**
 * SQLite backend detection — used by migrations and startup logic
 * to know whether the app is running on a SQLite backend (Capacitor native)
 * vs the default IndexedDB backend (browser).
 *
 * The flag is set by the dexie-sqlite addon during initialization.
 * When the addon is not loaded, this always returns false.
 */

let _sqliteActive = false

/**
 * Mark the SQLite backend as active.
 * Called by the dexie-sqlite addon during addon registration.
 */
export function setSqliteActive(active: boolean): void {
  _sqliteActive = active
}

/**
 * Check if the current database is backed by SQLite.
 * Returns false on web (IndexedDB) and true on Capacitor native.
 */
export function isSqliteActive(): boolean {
  return _sqliteActive
}
